import { isOneSignalConfigured } from "@/services/notifications/oneSignalClient"
import { isSupabaseConfigured } from "@/services/supabaseClient"

export type IntegrationStatus = {
  id: "supabase" | "auth" | "uploads" | "notifications" | "payments" | "publicSharing"
  label: string
  status: "connected" | "configured" | "disabled"
  message: string
}

export function getIntegrationStatuses(): IntegrationStatus[] {
  return [
    {
      id: "supabase",
      label: "Supabase backend",
      status: isSupabaseConfigured() ? "configured" : "disabled",
      message: isSupabaseConfigured()
        ? "Proofs, tasks, profiles, Passport summaries, feedback, and invitations can use Supabase."
        : "Set EXPO_PUBLIC_SUPABASE_URL and EXPO_PUBLIC_SUPABASE_ANON_KEY to enable backend writes.",
    },
    {
      id: "auth",
      label: "Supabase Auth",
      status: isSupabaseConfigured() ? "configured" : "disabled",
      message: isSupabaseConfigured()
        ? "Email/password, magic link, and configured OAuth providers are available from Account."
        : "Auth UI is present, but sign-in is disabled until Supabase env values are set.",
    },
    {
      id: "uploads",
      label: "Evidence uploads",
      status: isSupabaseConfigured() ? "configured" : "disabled",
      message: isSupabaseConfigured()
        ? "Proof evidence files upload to the private eq-proof-evidence bucket after sign-in."
        : "Evidence upload UI is present, but storage is disabled until Supabase env values are set.",
    },
    {
      id: "notifications",
      label: "Notifications",
      status: isSupabaseConfigured() && isOneSignalConfigured() ? "configured" : "disabled",
      message:
        isSupabaseConfigured() && isOneSignalConfigured()
          ? "OneSignal device registration syncs to Supabase when signed-in users enable push."
          : "Set Supabase env values and EXPO_PUBLIC_ONESIGNAL_APP_ID to enable push registration.",
    },
    {
      id: "payments",
      label: "Payments",
      status: "disabled",
      message: "Payments are blocked because no production billing provider exists in this repo.",
    },
    {
      id: "publicSharing",
      label: "Public sharing",
      status: isSupabaseConfigured() ? "configured" : "disabled",
      message: isSupabaseConfigured()
        ? "Passport share links use a Supabase RPC that exposes only curated public progress."
        : "Passport share routes are present, but publishing is disabled until Supabase env values are set.",
    },
  ]
}
